import ArrowIcon from 'assets/images/arrows/arrowIcon.svg?react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import Button from 'shared/components/form/button';
import './styles.scss';

interface ExpandButtonProps {
	isExpanded: boolean;
	onClick: () => void;
	btnHeight?: 'small' | 'medium' | 'large';
}

export const ExpandButton = ({ onClick, isExpanded, btnHeight = 'small' }: ExpandButtonProps) => {
	const { t } = useTranslation();
	return (
		<Button className="expandButton" onClick={onClick} btnType="ghost" btnHeight={btnHeight} type="button">
			<div className={cn('expandButton__icon', { 'expandButton__icon--expanded': isExpanded })}>
				<ArrowIcon />
			</div>
			{isExpanded ? t('collapse') : t('expand')}
		</Button>
	);
};

export default ExpandButton;
